<template>
  <v-flex>
    <v-row class="mt-2" justify="center">
      <v-col cols="12" md="12">
        <v-container fluid>
          <v-row justify="center">
            <span class="mx-4" style="font-size: 34px; color: #616161"
              >Distribución de cuentas</span
            >
          </v-row>
          <v-row justify="center" class="mt-n1 mx-2">
            <span style="font-size: 16px; color: #757575"
              >Utiliza las distribución para clasificar tus productos
            </span>
          </v-row>
          <v-row justify="start">
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="data_filtered"
                :search="search"
                sort-by="calories"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                  <v-col cols="12" sm="auto" md="auto" lg="auto">
                    <v-autocomplete
                      v-model="business_selected"
                      :items="$store.state.auth.bussines_units"
                      label="Unidad de negocio"
                      color="primary"
                      item-color="primary"
                      prepend-inner-icon="mdi-office-building-outline"
                      outlined
                      dense
                      hide-details
                    >
                    <template v-slot:prepend-inner>
                      <v-icon color="primary">mdi-office-building-outline</v-icon>
                    </template>
                  </v-autocomplete>
                </v-col>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer> </v-spacer>
                    <v-text-field
                      v-model="search"
                      dense outlined hide-details
                      label="Buscar.."
                    ></v-text-field>

                    <v-spacer></v-spacer>
                     <v-divider class="mx-4" inset vertical></v-divider>
                    <v-dialog v-model="dialog" width="70vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          outlined
                          color="primary"
                          dark v-if="$store.state.auth.globalFeatures.includes('CON-152')"
                          class="mb-2" dense hide-details
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon> add </v-icon>
                          Nueva distribución
                        </v-btn>
                      </template>
                      <v-card height="auto">
                        <v-row no-gutters justify="center">
                          <v-card-title class="text-center">
                            <span class="text-h5 text-center">{{
                              formTitle
                            }}</span>
                          </v-card-title>
                        </v-row>

                        <v-card-text>
                          <v-form ref="form" lazy-validation>
                            <v-row justify="center">
                              <v-col cols="12" md="12">
                                <v-container>
                                  <v-row justify="center">
                                    <v-col cols="12" md="10" class="mt-n4">
                                      <v-row no-gutters>
                                        <v-text-field
                                          v-model="editedItem.name"
                                          label="Nombre"
                                          outlined
                                          :rules="[
                                            (v) => !!v || 'Nombre es requerido',
                                          ]"
                                          dense
                                        ></v-text-field>
                                      </v-row>

                                      <v-row no-gutters>
                                        <v-textarea
                                          v-model="editedItem.note"
                                          label="Descripcion"
                                          outlined
                                          dense rows="2"
                                        ></v-textarea>
                                      </v-row>
                                      <!-- <v-row dense>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="
                                              editedItem.item_chart_of_account_id
                                            "
                                            :items="accounts"
                                            color="cyanText"
                                            label="Cuenta contable"
                                            outlined
                                            :rules="[
                                              (v) =>
                                                !!v || 'Cuenta es requerida',
                                            ]"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                      </v-row> -->
                                      <!-- <v-row dense>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="
                                              editedItem.cost_chart_of_account_id
                                            "
                                            :items="accounts"
                                            color="cyanText"
                                            label="Cuenta de costo de venta"
                                            :rules="[
                                              (v) =>
                                                !!v || 'Costo es requerido',
                                            ]"
                                            outlined
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                      </v-row> -->
                                      <!-- <v-row dense>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="
                                              editedItem.capital_asset_chart_of_account_id
                                            "
                                            :items="accounts"
                                            color="cyanText"
                                            label="Cuenta de activo fijo"
                                            outlined
                                            required
                                            :rules="[
                                              (v) =>
                                                !!v || 'Cuenta es requerida',
                                            ]"
                                          ></v-autocomplete>
                                        </v-col>
                                      </v-row> -->
                                    
                                      <v-row dense>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="
                                              editedItem.selling_chart_of_account_id
                                            "
                                            :items="accounts"
                                            color="cyanText"
                                            label="Cuenta de venta"
                                            outlined
                                            :rules="[
                                              (v) =>
                                                !!v || 'Cuenta es requerida',
                                            ]"
                                            required
                                          >
                                          </v-autocomplete>
                                        </v-col>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="editedItem.selling_category_id"
                                            :disabled="!editedItem.selling_chart_of_account_id"
                                            :items="
                                              categoriesForAccount(categories, editedItem.selling_chart_of_account_id)
                                            "
                                            color="cyanText"
                                            label="Categoria de venta "
                                            outlined
                                            item-text="name"
                                            item-value="id"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="editedItem.selling_subcategory_id"
                                            :disabled="!editedItem.selling_category_id"
                                            :items="
                                              subcategoriesForAccount(categories, editedItem.selling_chart_of_account_id, editedItem.selling_category_id)
                                            "
                                            color="cyanText"
                                            label="Sub-Categoria de venta "
                                            outlined
                                            item-text="name"
                                            item-value="id"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                      </v-row>

                                      <v-row dense>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="
                                              editedItem.buying_chart_of_account_id
                                            "
                                            :items="accounts"
                                            color="cyanText"
                                            label="Cuenta de compra "
                                            outlined
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="editedItem.buying_category_id"
                                            :disabled="!editedItem.buying_chart_of_account_id"
                                            :items="
                                              categoriesForAccount(categories, editedItem.buying_chart_of_account_id)
                                            "
                                            color="cyanText"
                                            label="Categoría de compra "
                                            outlined
                                            item-text="name"
                                            item-value="id"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="editedItem.buying_subcategory_id"
                                            :disabled="!editedItem.buying_category_id"
                                            :items="
                                              subcategoriesForAccount(categories, editedItem.buying_chart_of_account_id, editedItem.buying_category_id)
                                            "
                                            color="cyanText"
                                            label="Sub-Categoria de compra "
                                            outlined
                                            item-text="name"
                                            item-value="id"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                      </v-row>
                                        <v-row dense>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="editedItem.inventory_chart_of_account_id"
                                            :items="accounts"
                                            color="cyanText"
                                            label="Cuenta de inventario"
                                            outlined
                                            :rules="[
                                              (v) =>
                                                !!v || 'Cuenta es requerida',
                                            ]"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="
                                              editedItem.inventory_category_id
                                            "
                                            :disabled="
                                              !editedItem.inventory_chart_of_account_id
                                            "
                                            :items="
                                              categoriesForAccount(categories, editedItem.inventory_chart_of_account_id)
                                            "
                                            color="cyanText"
                                            label="Categoria de inventario"
                                            outlined
                                            item-text="name"
                                            item-value="id"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="
                                              editedItem.inventory_subcategory_id
                                            "
                                            :disabled="
                                              !editedItem.inventory_category_id
                                            "
                                            :items="
                                              subcategoriesForAccount(categories, editedItem.inventory_chart_of_account_id, editedItem.inventory_category_id)
                                            "
                                            color="cyanText"
                                            label="Sub Categoria de inventario"
                                            outlined
                                            item-text="name"
                                            item-value="id"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                      </v-row>
                                        <v-row dense>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="editedItem.cost_chart_of_account_id"
                                            :items="accounts"
                                            color="cyanText"
                                            label="Cuenta de costo"
                                            outlined
                                            :rules="[
                                              (v) =>
                                                !!v || 'Cuenta es requerida',
                                            ]"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="editedItem.cost_category_id"
                                            :disabled=" !editedItem.cost_chart_of_account_id"
                                            :items="
                                              categoriesForAccount(categories, editedItem.cost_chart_of_account_id)
                                            "
                                            color="cyanText"
                                            label="Categoria de costo"
                                            outlined
                                            item-text="name"
                                            item-value="id"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="4">
                                          <v-autocomplete
                                            dense
                                            v-model="editedItem.cost_subcategory_id"
                                            :disabled="!editedItem.cost_category_id"
                                            :items="
                                              subcategoriesForAccount(categories, editedItem.cost_chart_of_account_id, editedItem.cost_category_id)
                                            "
                                            color="cyanText"
                                            label="Sub Categoria de costo"
                                            outlined
                                            item-text="name"
                                            item-value="id"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-card-text>

                        <v-card-actions class="mt-0">
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="close">
                            Cancelar
                          </v-btn>
                          <v-btn outlined color="blue darken-1" @click="save" v-if="$store.state.auth.globalFeatures.includes('CON-152')">
                            Guardar
                          </v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete" max-width="600px">
                      <v-card>
                        <v-card-title class="text-h5"
                          >Estas seguro que desea eliminar?</v-card-title
                        >
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="closeDelete"
                            >Cancel</v-btn
                          >
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="deleteItemConfirm"
                            >OK</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>

                <template v-slot:[`item.options`]="{ item }">
                  <span v-for="(items, i) of item.letiants_details" :key="i">
                    {{ items.letiant.name }} /
                  </span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon 
                        v-bind="attrs"
                        v-on="on"
                        medium
                        color="blue"
                        @click="editItem(item)"
                      >
                        mdi-pencil
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <!-- <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon> -->
                </template>
                <template v-slot:no-data>
                  <v-row justify="center" class="pt-10">
                    <v-icon size="80px">token</v-icon>
                  </v-row>
                  <v-row justify="center" class="pb-6"> No hay datos </v-row>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-col></v-row
    >
  </v-flex>
</template>

<script>
import accountCategoryRules from "../../mixins/accountCategoryRules";
export default {
  mixins: [accountCategoryRules],
  data: () => ({
    dialog: false,
    dialogDelete: false,
    itemsletiant: [],
    search: null,
    headers: [
      {
        text: "Codigo",
        align: "start",
        sortable: false,
        value: "id",
      },
      { text: "Nombre", value: "name" },
      {
        text: "Cuenta de inventario",
        value: "inventory_chart_of_account_name",
      },
      { text: "Cuenta de costo de venta", value: "cost_chart_of_account_name" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    data: [],
    accounts: [],
    categories: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      item_chart_of_account_id: null,
      inventory_chart_of_account_id: null,
      cost_chart_of_account_id: null,
      buying_chart_of_account_id: null,
      selling_chart_of_account_id: null,
    },
    defaultItem: {
      name: "",
      item_chart_of_account_id: null,
      inventory_chart_of_account_id: null,
      cost_chart_of_account_id: null,

    },
    business_selected: null,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva distribución" : "Editar distribución";
    },
    data_filtered() {
      return this.data.filter((element) =>element.business_unit_id == this.business_selected);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      const result = await Promise.all([
        this.api_Get("accounting/categories"),
        this.api_Get("accounting/accountsUsable"),
        this.api_Get("accounting/categories_diary_book"),
      ]);
      this.data = await result[0].json();
  
      const dataTypeAccounts = await result[1].json();
      for (let item of dataTypeAccounts) {
     
        this.accounts.push({
          text: item.code + " - " + item.name,
          value: item.id,
          dgii_category_id: item.dgii_category_id,
        });
      }
      this.categories = await result[2].json();
      this.business_selected = this.$store.state.app.filters.business || this.$store.state.auth.bussines_units[0].id;
    },
    validate() {
      return this.$refs.form.validate();
    },

    editItem(item) {
      this.itemsletiant = [];
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.data.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (!this.validate()) {
        return;
      }
      if (this.editedIndex > -1) {
        let data = {
          id: this.editedItem.id,
          inventory_chart_of_account_id: this.editedItem.inventory_chart_of_account_id,
          inventory_category_id: this.editedItem.inventory_category_id==undefined?null:this.editedItem.inventory_category_id,
          inventory_subcategory_id: this.editedItem.inventory_subcategory_id==undefined?null:this.editedItem.inventory_subcategory_id,
          cost_chart_of_account_id: this.editedItem.cost_chart_of_account_id==undefined?null:this.editedItem.cost_chart_of_account_id,
          cost_category_id: this.editedItem.cost_category_id==undefined?null:this.editedItem.cost_category_id,
          cost_subcategory_id: this.editedItem.cost_subcategory_id==undefined?null:this.editedItem.cost_subcategory_id,
          selling_chart_of_account_id: this.editedItem.selling_chart_of_account_id,
          selling_category_id: this.editedItem.selling_category_id==undefined?null:this.editedItem.selling_category_id,
          selling_subcategory_id: this.editedItem.selling_subcategory_id==undefined?null:this.editedItem.selling_subcategory_id,
          buying_chart_of_account_id: this.editedItem.buying_chart_of_account_id==undefined?null:this.editedItem.buying_chart_of_account_id,
          buying_category_id: this.editedItem.buying_category_id==undefined?null:this.editedItem.buying_category_id,
          buying_subcategory_id: this.editedItem.buying_subcategory_id==undefined?null:this.editedItem.buying_subcategory_id,
          name: this.editedItem.name,
          note: this.editedItem.note==undefined?null:this.editedItem.note,
        };

        const responseRequest = await this.api_Put(
          "accounting/categories",
          data
        );

        if (responseRequest.status == 200) {
          this.initialize();
          this.close();
        } else {
          this.$toast.error("error al actualizar!");
        }
      } else {


        let data = {
          inventory_chart_of_account_id: this.editedItem.inventory_chart_of_account_id,
          inventory_category_id: this.editedItem.inventory_category_id==undefined?null:this.editedItem.inventory_category_id,
          inventory_subcategory_id: this.editedItem.inventory_subcategory_id==undefined?null:this.editedItem.inventory_subcategory_id,
          selling_chart_of_account_id: this.editedItem.selling_chart_of_account_id==undefined?null:this.editedItem.selling_chart_of_account_id,
          selling_category_id: this.editedItem.selling_category_id==undefined?null:this.editedItem.selling_category_id,
          selling_subcategory_id: this.editedItem.selling_subcategory_id==undefined?null:this.editedItem.selling_subcategory_id,
          buying_chart_of_account_id: this.editedItem.buying_chart_of_account_id==undefined?null:this.editedItem.buying_chart_of_account_id,
          buying_category_id: this.editedItem.buying_category_id==undefined?null:this.editedItem.buying_category_id,
          buying_subcategory_id: this.editedItem.buying_subcategory_id==undefined?null:this.editedItem.buying_subcategory_id,
          cost_chart_of_account_id: this.editedItem.cost_chart_of_account_id==undefined?null:this.editedItem.cost_chart_of_account_id,
          cost_category_id: this.editedItem.cost_category_id==undefined?null:this.editedItem.cost_category_id,
          cost_subcategory_id: this.editedItem.cost_subcategory_id==undefined?null:this.editedItem.cost_subcategory_id,
          name: this.editedItem.name,
          note: this.editedItem.note==undefined?null:this.editedItem.note,
          business_unit_id: this.business_selected,
        };

        const responseRequest = await this.api_Post(
          "accounting/categories",
          data
        );

        if (responseRequest.status == 200) {
          //this.api_Get("accounting/categories");
          this.close();
          // this.$toast.success("agregado con exito!");
          this.dialog = false;
        } else {
          this.$toast.error("error al agregar!");
        }
      }

   
    },
  },
};
</script>
